import React, { useState, useEffect, useRef } from 'react';
import '../../Css/Botones/botones.css';
import '../../Css/catalogobase/catalogobase.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Badge } from 'primereact/badge';
import Navbar from '../../components/navbar/navbar';
import Sidebar from '../../components/sidebar/sidebar';
import { API_URLS } from '../../Services/servicioURL';
import { BASE_URL } from '../../Services/servicioURL';
import ResponsiveMaintenanceTable from '../../components/contenido/TablaResponsivaMan';

// Interfaces
interface Producto {
    id: number;
    producto: string;
    descripcion: string;
    cantidad: number;
    observaciones?: string;
}
interface ProductoCatalogo {
    cve: string;
    descripcion: string;
    modelo: string;
    serie: string;
    mantenimiento?: boolean;
}
interface MantenimientoDetalle {
    folio: string;
    id: number;
    cve_producto: string;
    cantidad: number;
    observaciones: string;
}
interface MantenimientoType {
    folio: string;
    fecha: string;
    id_usuario_capturo: number;
    id_tecnico: number;
    cve_producto: string;
    observaciones: string;
    mantenimientoDetalle: MantenimientoDetalle[];
}

const obtenerUsuarios = async () => {
    const response = await fetch(`${BASE_URL}/usuario/getUsuarios`);
    if (!response.ok) throw new Error('Error al obtener usuarios');
    return await response.json();
};

const obtenerProductos = async () => {
    const response = await fetch(API_URLS.productos.obtener);
    if (!response.ok) throw new Error('Error al obtener productos');
    return await response.json();
};
const obtenerProductosMantenimiento = async () => {
    const response = await fetch(API_URLS.productos.obtener);
    if (!response.ok) throw new Error('Error al obtener productos de mantenimiento');
    const productos = await response.json();
    // Filtrar solo productos que tienen mantenimiento: true
    return productos.filter((producto: any) => producto.mantenimiento === true);
};

const Mantenimiento: React.FC = () => {
    // Estados principales
    const [folio, setFolio] = useState('');
    const [fecha, setFecha] = useState('');
    const [idUsuarioCapturo, setIdUsuarioCapturo] = useState<number | null>(null);
    const [idTecnico, setIdTecnico] = useState<number | null>(null);
    const [cveProductoMantenimiento, setCveProductoMantenimiento] = useState<string>('');
    const [observaciones, setObservaciones] = useState('');
    const [loading, setLoading] = useState<boolean>(true);
    const [usuarios, setUsuarios] = useState<any[]>([]);
    const [products, setProducts] = useState<Producto[]>([]);
    const [nextId, setNextId] = useState<number>(1);
    const [mode, setMode] = useState<'view' | 'new' | 'edit'>('view');
    const [editar, setEditar] = useState<boolean>(false);
    const [selectedProductIndex, setSelectedProductIndex] = useState<number | null>(null);
    const [isFechaDisabled, setIsFechaDisabled] = useState<boolean>(true);
    const toast = useRef<Toast>(null);

    // Estados para buscador de productos
    const [nombreProducto, setNombreProducto] = useState<string>('');
    const [DescripcionProducto, setDescripcionProducto] = useState<string>('');
    const [cantidadProducto, setCantidadProducto] = useState<string>('');
    const [descripcionProductoPrincipal, setDescripcionProductoPrincipal] = useState<string>('');
    const [observacionProducto, setObservacionProducto] = useState<string>('');
    const [productosCatalogo, setProductosCatalogo] = useState<ProductoCatalogo[]>([]);
    const [productosFiltered, setProductosFiltered] = useState<ProductoCatalogo[]>([]);
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [mostrarBuscadorProductos, setMostrarBuscadorProductos] = useState<boolean>(false);
    const [productosMantenimiento, setProductosMantenimiento] = useState<ProductoCatalogo[]>([]);
    const [productosMantenimientoFiltered, setProductosMantenimientoFiltered] = useState<ProductoCatalogo[]>([]);
    const [searchTermMantenimiento, setSearchTermMantenimiento] = useState<string>('');

    // Estados para consulta
    const [mostrarTablaConsultaEntradas, setMostrarTablaConsultaEntradas] = useState<boolean>(false);
    const [salidasConsulta, setSalidasConsulta] = useState<MantenimientoType[]>([]);
    const [filteredSalidas, setFilteredSalidas] = useState<MantenimientoType[]>([]);
    const [searchTermSalida, setSearchTermSalida] = useState<string>('');

    // Cargar datos iniciales
    useEffect(() => {
    const fetchInitialData = async () => {
        try {
            const [usuariosData, productosData, productosMantenimientoData] = await Promise.all([
                obtenerUsuarios(),
                obtenerProductos(),
                obtenerProductosMantenimiento()
            ]);
            setUsuarios(usuariosData);
            setProductosCatalogo(productosData);
            setProductosFiltered(productosData);
            setProductosMantenimiento(productosMantenimientoData);
            setProductosMantenimientoFiltered(productosMantenimientoData);
        } catch (error) {
            console.error('Error al cargar datos:', error);
        } finally {
            setLoading(false);
        }
    };
    fetchInitialData();
}, []);

useEffect(() => {
    if (searchTermMantenimiento.trim()) {
        const filtered = productosMantenimiento.filter(p =>
            p.cve.toLowerCase().includes(searchTermMantenimiento.toLowerCase()) ||
            p.descripcion.toLowerCase().includes(searchTermMantenimiento.toLowerCase())
        );
        setProductosMantenimientoFiltered(filtered);
    } else {
        setProductosMantenimientoFiltered(productosMantenimiento);
    }
}, [searchTermMantenimiento, productosMantenimiento]);

    // Establecer fecha actual
    useEffect(() => {
        const fechaActualISO = new Date().toISOString().split('T')[0];
        setFecha(fechaActualISO);
    }, []);

    // Cargar último folio si es nuevo
    useEffect(() => {
        const cargarFolioAutomatico = async () => {
            const url = `${BASE_URL}/mantenimiento/getMantenimientos`;
            try {
                const response = await fetch(url);
                if (!response.ok) throw new Error('No se pudo obtener el último folio');
                const data = await response.json();
                const folios = data.map((e: any) => parseInt(e.folio)).filter(Number);
                const ultimoFolio = folios.length ? Math.max(...folios) : 0;
                setFolio((ultimoFolio + 1).toString());
            } catch {
                setFolio('1');
            }
        };
        if (mode === 'new') {
            cargarFolioAutomatico();
        }
    }, [mode]);

    // Cargar ID del usuario logueado
    useEffect(() => {
        const idUsuarioString = localStorage.getItem('idUsuario');
        const idUsuario = idUsuarioString ? parseInt(idUsuarioString) : null;
        setIdUsuarioCapturo(idUsuario);
    }, []);

    // Filtrar catálogo de productos
    useEffect(() => {
        if (searchTerm.trim()) {
            const filtered = productosCatalogo.filter(p =>
                p.cve.toLowerCase().includes(searchTerm.toLowerCase()) ||
                p.descripcion.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setProductosFiltered(filtered);
        } else {
            setProductosFiltered(productosCatalogo);
        }
    }, [searchTerm, productosCatalogo]);

    // Filtrar mantenimientos en consulta
    useEffect(() => {
        if (searchTermSalida.trim()) {
            const filtered = salidasConsulta.filter(salida =>
                salida.folio.toLowerCase().includes(searchTermSalida.toLowerCase()) ||
                salida.observaciones.toLowerCase().includes(searchTermSalida.toLowerCase())
            );
            setFilteredSalidas(filtered);
        } else {
            setFilteredSalidas(salidasConsulta);
        }
    }, [searchTermSalida, salidasConsulta]);

    // NUEVA FUNCIÓN: Agregar producto genérico de Limpieza/Mantenimiento
    const agregarLimpiezaMantenimiento = () => {
        if (mode === 'view') {
            toast.current?.show({
                severity: 'warn',
                summary: 'Advertencia',
                detail: 'No se puede agregar productos en modo consulta',
                life: 3000
            });
            return;
        }

        // Verificar si ya existe un producto de limpieza/mantenimiento
        const existeLimpieza = products.some(p => 
            p.producto === 'LIMPIEZA-MANT' || 
            p.descripcion.toLowerCase().includes('limpieza') ||
            p.descripcion.toLowerCase().includes('mantenimiento')
        );

        if (existeLimpieza) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Advertencia',
                detail: 'Ya existe un producto de Limpieza/Mantenimiento en la lista',
                life: 3000
            });
            return;
        }

        const productoLimpieza: Producto = {
            id: nextId,
            producto: 'LIMPIEZA-MANT',
            descripcion: 'Limpieza/Mantenimiento General',
            cantidad: 1,
            observaciones: 'Servicio de limpieza y mantenimiento preventivo'
        };

        setProducts([...products, productoLimpieza]);
        setNextId(nextId + 1);

        toast.current?.show({
            severity: 'success',
            summary: '¡Éxito!',
            detail: 'Producto de Limpieza/Mantenimiento agregado correctamente',
            life: 3000
        });
    };

    // Buscar mantenimientos
    const handleBuscarSalida = async () => {
        try {
            const response = await fetch(`${BASE_URL}/mantenimiento/getMantenimientos`);
            if (!response.ok) throw new Error('Error al obtener los mantenimientos');
            const data = await response.json();
            setSalidasConsulta(data);
            setFilteredSalidas(data);
            setMostrarTablaConsultaEntradas(true);
        } catch (error) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudieron cargar los mantenimientos',
                life: 3000
            });
        }
    };

    const cerrarTablaConsultaEntradas = () => {
        setMostrarTablaConsultaEntradas(false);
        setSearchTermSalida('');
    };

    const handleSeleccionarSalida = (salida: MantenimientoType) => {
        setFolio(salida.folio);
        setFecha(salida.fecha);
        setIdUsuarioCapturo(salida.id_usuario_capturo);
        setIdTecnico(salida.id_tecnico);
        setCveProductoMantenimiento(salida.cve_producto);
        setObservaciones(salida.observaciones);
        const productosMap: Producto[] = salida.mantenimientoDetalle.map((detalle) => ({
            id: detalle.id,
            producto: detalle.cve_producto,
            descripcion: detalle.cve_producto,
            cantidad: detalle.cantidad,
            observaciones: detalle.observaciones
        }));
        setProducts(productosMap);
        const productoPrincipal = productosCatalogo.find(p => p.cve === salida.cve_producto);
        if (productoPrincipal) {
            setDescripcionProductoPrincipal(productoPrincipal.descripcion);
        }
        setMode('view');
        setIsFechaDisabled(true);
        cerrarTablaConsultaEntradas();
    };

    // Limpiar formulario
    const handleCancelar = () => {
        setFolio('');
        setFecha(new Date().toISOString().split('T')[0]);
        setIdTecnico(null);
        setCveProductoMantenimiento('');
        setObservaciones('');
        setProducts([]);
        clearProductFields();
        setMode('view');
        setIsFechaDisabled(true);
    };

    // Agregar o actualizar un producto
    const addProduct = () => {
        if (!nombreProducto || !DescripcionProducto || !cantidadProducto) {
            toast.current?.show({ 
                severity: 'warn', 
                summary: 'Campos requeridos', 
                detail: 'Los campos Producto, Descripción y Cantidad son obligatorios', 
                life: 3000 
            });
            return;
        }
        const newProduct: Producto = {
            id: nextId,
            producto: nombreProducto,
            descripcion: DescripcionProducto,
            cantidad: parseInt(cantidadProducto),
            observaciones: observacionProducto
        };
        setProducts([...products, newProduct]);
        setNextId(nextId + 1);
        clearProductFields();
        toast.current?.show({ 
            severity: 'success', 
            summary: '¡Éxito!', 
            detail: 'Producto agregado correctamente', 
            life: 3000 
        });
    };

    const updateProduct = () => {
        if (!nombreProducto || !DescripcionProducto || !cantidadProducto || selectedProductIndex === null) {
            toast.current?.show({ 
                severity: 'warn', 
                summary: 'Advertencia', 
                detail: 'Seleccione un producto para actualizar', 
                life: 3000 
            });
            return;
        }
        const updatedProduct: Producto = {
            id: products[selectedProductIndex].id,
            producto: nombreProducto,
            descripcion: DescripcionProducto,
            cantidad: parseInt(cantidadProducto),
            observaciones: observacionProducto
        };
        const updatedProducts = [...products];
        updatedProducts[selectedProductIndex] = updatedProduct;
        setProducts(updatedProducts);
        clearProductFields();
        toast.current?.show({ 
            severity: 'success', 
            summary: '¡Actualizado!', 
            detail: 'Producto actualizado correctamente', 
            life: 3000 
        });
    };

    const deleteProduct = (id: number) => {
        const confirmacion = window.confirm('⚠️ ¿Está seguro de eliminar este producto?\n\nEsta acción no se puede deshacer.');
        if (!confirmacion) return;
        setProducts(products.filter(p => p.id !== id));
        toast.current?.show({ 
            severity: 'success', 
            summary: '¡Eliminado!', 
            detail: 'Producto eliminado correctamente', 
            life: 3000 
        });
    };

    const selectProductForEdit = (product: Producto, index: number) => {
        setNombreProducto(product.producto);
        setDescripcionProducto(product.descripcion);
        setCantidadProducto(product.cantidad.toString());
        setObservacionProducto(product.observaciones || '');
        setSelectedProductIndex(index);
        setEditar(true);
        toast.current?.show({ 
            severity: 'info', 
            summary: 'Modo edición', 
            detail: 'Puede editar los campos del producto', 
            life: 3000 
        });
    };

    const actionBodyTemplate = (rowData: Producto) => (
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
            <Button 
                icon="pi pi-pencil" 
                size="small"
                severity="warning"
                rounded
                onClick={() => selectProductForEdit(rowData, products.findIndex(p => p.id === rowData.id))}
                disabled={mode === 'view'}
                tooltip="Editar producto"
            />
            <Button 
                icon="pi pi-trash" 
                size="small"
                severity="danger"
                rounded
                onClick={() => deleteProduct(rowData.id)}
                disabled={mode === 'view'}
                tooltip="Eliminar producto"
            />
        </div>
    );

    // Buscador de productos
    const abrirBuscadorProductos = async (tipo: 'principal' | 'detalle' = 'detalle') => {
    try {
        setLoading(true);
        setTipoSeleccion(tipo);
        
        if (tipo === 'principal') {
            // Para producto principal, usar solo productos con mantenimiento: true
            const productosMantenimientoData = await obtenerProductosMantenimiento();
            setProductosMantenimiento(productosMantenimientoData);
            setProductosMantenimientoFiltered(productosMantenimientoData);
            setSearchTermMantenimiento('');
        } else {
            // Para detalles, usar todos los productos
            const productos = await obtenerProductos();
            setProductosCatalogo(productos);
            setProductosFiltered(productos);
            setSearchTerm('');
        }
        
        setMostrarBuscadorProductos(true);
    } catch {
        toast.current?.show({ 
            severity: 'error', 
            summary: 'Error', 
            detail: 'No se pudieron cargar los productos', 
            life: 3000 
        });
    } finally {
        setLoading(false);
    }
};

    const cerrarBuscadorProductos = () => {
    setMostrarBuscadorProductos(false);
    setSearchTerm('');
    setSearchTermMantenimiento('');
};

    const [tipoSeleccion, setTipoSeleccion] = useState<'principal' | 'detalle'>('detalle');

    const seleccionarProductoCatalogo = (producto: ProductoCatalogo) => {
        if (tipoSeleccion === 'principal') {
            setCveProductoMantenimiento(producto.cve);
            setDescripcionProductoPrincipal(producto.descripcion);
        } else {
            setNombreProducto(producto.cve);
            setDescripcionProducto(producto.descripcion);
            setCantidadProducto('1');
        }
        setMostrarBuscadorProductos(false);
        toast.current?.show({
            severity: 'info',
            summary: 'Producto seleccionado',
            detail: `Se ha seleccionado: ${producto.descripcion}`,
            life: 3000
        });
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (tipoSeleccion === 'principal') {
        setSearchTermMantenimiento(e.target.value);
    } else {
        setSearchTerm(e.target.value);
    }
};

    const clearProductFields = () => {
        setNombreProducto('');
        setDescripcionProducto('');
        setCantidadProducto('');
        setObservacionProducto('');
        setEditar(false);
        setSelectedProductIndex(null);
    };

    const limpiarFormulario = () => {
        setFolio('');
        setFecha(new Date().toISOString().split('T')[0]);
        setIdTecnico(null);
        setCveProductoMantenimiento('');
        setDescripcionProductoPrincipal('');
        setObservaciones('');
        setProducts([]);
        clearProductFields();
    };

    // Nuevo - Botón "Nuevo"
    const handleNuevo = () => {
        limpiarFormulario();
        setMode('new');
        setIsFechaDisabled(false);
    };

    // Editar - Botón "Editar"
    const handleEditar = () => {
        if (!folio) {
            toast.current?.show({ 
                severity: 'warn', 
                summary: 'Advertencia', 
                detail: 'Seleccione un mantenimiento para editar', 
                life: 3000 
            });
            return;
        }
        setMode('edit');
        setIsFechaDisabled(false);
    };

    // Eliminar - Botón "Eliminar"
    const handleEliminar = () => {
        if (!folio) {
            toast.current?.show({ 
                severity: 'warn', 
                summary: 'Advertencia', 
                detail: 'Seleccione un mantenimiento para eliminar', 
                life: 3000 
            });
            return;
        }
        const confirmacion = window.confirm(`⚠️ ¿Está seguro de eliminar el mantenimiento con folio: ${folio}?\n\nEsta acción no se puede deshacer.`);
        if (!confirmacion) return;
        fetch(`${BASE_URL}/mantenimiento/eliminarMantenimiento/${folio}`, {
            method: 'DELETE'
        })
            .then(res => res.json())
            .then(() => {
                toast.current?.show({ 
                    severity: 'success', 
                    summary: '¡Eliminado!', 
                    detail: 'Mantenimiento eliminado correctamente', 
                    life: 3000 
                });
                limpiarFormulario();
            })
            .catch(err => {
                console.error("Error al eliminar:", err);
                toast.current?.show({ 
                    severity: 'error', 
                    summary: 'Error', 
                    detail: 'No se pudo eliminar el mantenimiento', 
                    life: 3000 
                });
            });
    };

    // Guardar mantenimiento
    const handleGuardar = () => {
        if (!folio || !fecha || !idUsuarioCapturo || !idTecnico || !cveProductoMantenimiento) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Campos requeridos',
                detail: 'Todos los campos con * son obligatorios',
                life: 3000
            });
            return;
        }
        if (products.length === 0) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Advertencia',
                detail: 'Debe agregar al menos un producto',
                life: 3000
            });
            return;
        }

        const mantenimientoDetalle = products.map((producto) => {
            const { id, ...rest } = producto;
            return {
                ...(mode !== 'new' && id ? { id } : {}),
                folio,
                cve_producto: producto.producto,
                cantidad: producto.cantidad,
                observaciones: producto.observaciones || ''
            };
        });

        const payload = {
            folio,
            fecha,
            id_usuario_capturo: idUsuarioCapturo,
            id_tecnico: idTecnico,
            cve_producto: cveProductoMantenimiento,
            observaciones: observaciones || '',
            mantenimientoDetalle
        };

        console.log("PAYLOAD ENVIADO AL BACKEND:", payload);

        fetch(`${BASE_URL}/mantenimiento/registrar`, {
            method: mode === 'new' ? 'POST' : 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        })
            .then(response => {
                if (!response.ok) throw new Error(mode === 'new' ? 'Error al registrar' : 'Error al actualizar');
                return response.json();
            })
            .then(() => {
                toast.current?.show({
                    severity: 'success',
                    summary: '¡Éxito!',
                    detail: `${mode === 'new' ? 'Registrado' : 'Actualizado'} exitosamente`,
                    life: 3000
                });
                limpiarFormulario();
                setMode('view');
            })
            .catch(error => {
                console.error("Error al guardar:", error);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message,
                    life: 3000
                });
            });
    };

    // Función para obtener información del modo actual
    const getModeIndicator = () => {
        switch (mode) {
            case 'new':
                return { text: 'NUEVO MANTENIMIENTO', color: '#10b981', icon: 'pi-plus' };
            case 'edit':
                return { text: 'EDITANDO MANTENIMIENTO', color: '#f59e0b', icon: 'pi-pencil' };
            default:
                return { text: 'MODO CONSULTA', color: '#6b7280', icon: 'pi-eye' };
        }
    };

    const modeInfo = getModeIndicator();

    return (
        <>
            <Navbar />
            <Sidebar />
            <Toast ref={toast} />

            {/* MODAL - Catálogo de Productos mejorado */}
            {mostrarBuscadorProductos && (
                <div className="overlay" onClick={cerrarBuscadorProductos} style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div className="floating-window" onClick={(e) => e.stopPropagation()} style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '20px',
                        maxWidth: '1000px',
                        width: '95%',
                        maxHeight: '85vh',
                        display: 'flex',
                        flexDirection: 'column',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                            <h3 style={{ margin: 0, color: '#1f2937', fontSize: '1.4rem', fontWeight: '600' }}>
                                {tipoSeleccion === 'principal' ? '🔧 Productos para Mantenimiento' : '📦 Catálogo de Productos'}
                            </h3>
                            <Button
                                icon="pi pi-times"
                                className="p-button-text p-button-rounded"
                                onClick={cerrarBuscadorProductos}
                                style={{ color: '#6b7280' }}
                            />
                        </div>

                        <div style={{ marginBottom: '16px' }}>
                            <div style={{ position: 'relative' }}>
                                <i className="pi pi-search" style={{
                                    position: 'absolute',
                                    left: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    color: '#9ca3af',
                                    fontSize: '0.9rem'
                                }}></i>
                                <InputText
                                    style={{
                                        width: '100%',
                                        height: '36px',
                                        paddingLeft: '35px',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '6px',
                                        fontSize: '0.9rem'
                                    }}
                                    placeholder="Buscar por clave, descripción o modelo..."
                                    value={tipoSeleccion === 'principal' ? searchTermMantenimiento : searchTerm}
                                    onChange={handleSearchChange}
                                />
                            </div>
                        </div>

                        {tipoSeleccion === 'principal' && (
                            <div style={{ 
                                marginBottom: '12px', 
                                fontSize: '0.85em', 
                                color: '#059669',
                                padding: '6px 10px',
                                backgroundColor: '#ecfdf5',
                                borderRadius: '4px',
                                border: '1px solid #a7f3d0',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}>
                                <i className="pi pi-info-circle" style={{ color: '#059669' }}></i>
                                <span>
                                    <strong>Filtro activo:</strong> Solo productos que pueden recibir mantenimiento
                                </span>
                            </div>
                        )}

                        <div style={{ 
                            marginBottom: '12px', 
                            fontSize: '0.85em', 
                            color: '#6b7280',
                            padding: '6px 10px',
                            backgroundColor: '#f9fafb',
                            borderRadius: '4px',
                            border: '1px solid #e5e7eb'
                        }}>
                            📊 Mostrando <strong>
                                {tipoSeleccion === 'principal' ? productosMantenimientoFiltered.length : productosFiltered.length}
                            </strong> de <strong>
                                {tipoSeleccion === 'principal' ? productosMantenimiento.length : productosCatalogo.length}
                            </strong> productos
                        </div>

                        {/* Tabla con DataTable de PrimeReact */}
                        <div style={{ flex: 1, overflow: 'hidden' }}>
                            <DataTable 
                                value={tipoSeleccion === 'principal' ? productosMantenimientoFiltered : productosFiltered}
                                scrollable 
                                scrollHeight="flex"
                                loading={loading}
                                emptyMessage={tipoSeleccion === 'principal' ? 
                                    "🔧 No hay productos disponibles para mantenimiento" : 
                                    "📭 No se encontraron productos"
                                }
                                size="small"
                                stripedRows
                                rowHover
                                onRowClick={(e) => seleccionarProductoCatalogo(e.data as ProductoCatalogo)}                                style={{ 
                                    fontSize: '0.85rem',
                                    cursor: 'pointer'
                                }}
                                rowClassName={() => 'cursor-pointer'}
                            >
                                <Column 
                                    field="cve" 
                                    header="🔑 Clave" 
                                    style={{ 
                                        width: '120px',
                                        padding: '6px 8px',
                                        fontSize: '0.85rem'
                                    }}
                                    headerStyle={{ 
                                        padding: '8px',
                                        fontSize: '0.9rem',
                                        fontWeight: '600'
                                    }}
                                />
                                <Column 
                                    field="descripcion" 
                                    header="📝 Descripción" 
                                    style={{ 
                                        minWidth: '250px',
                                        padding: '6px 8px',
                                        fontSize: '0.85rem'
                                    }}
                                    headerStyle={{ 
                                        padding: '8px',
                                        fontSize: '0.9rem',
                                        fontWeight: '600'
                                    }}
                                />
                                <Column 
                                    field="modelo" 
                                    header="🏷️ Modelo" 
                                    style={{ 
                                        width: '150px',
                                        padding: '6px 8px',
                                        fontSize: '0.85rem'
                                    }}
                                    headerStyle={{ 
                                        padding: '8px',
                                        fontSize: '0.9rem',
                                        fontWeight: '600'
                                    }}
                                />
                                <Column 
                                    field="serie" 
                                    header="🔢 Serie" 
                                    style={{ 
                                        width: '120px',
                                        padding: '6px 8px',
                                        fontSize: '0.85rem'
                                    }}
                                    headerStyle={{ 
                                        padding: '8px',
                                        fontSize: '0.9rem',
                                        fontWeight: '600'
                                    }}
                                />
                                {tipoSeleccion === 'principal' && (
                                    <Column 
                                        header="🔧 Mantenimiento" 
                                        style={{ 
                                            width: '120px',
                                            textAlign: 'center',
                                            padding: '6px 8px'
                                        }}
                                        headerStyle={{ 
                                            padding: '8px',
                                            fontSize: '0.9rem',
                                            fontWeight: '600'
                                        }}
                                        body={() => (
                                            <Badge 
                                                value="✅ Sí" 
                                                severity="success"
                                                style={{ fontSize: '0.75rem' }}
                                            />
                                        )}
                                    />
                                )}
                            </DataTable>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL - Tabla de Consulta de Mantenimientos mejorado */}
            {mostrarTablaConsultaEntradas && (
                <div className="overlay" onClick={cerrarTablaConsultaEntradas} style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div className="floating-window" onClick={(e) => e.stopPropagation()} style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '20px',
                        maxWidth: '900px',
                        width: '95%',
                        maxHeight: '85vh',
                        display: 'flex',
                        flexDirection: 'column',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                            <h3 style={{ margin: 0, color: '#1f2937', fontSize: '1.4rem', fontWeight: '600' }}>
                                🔧 Consultar Mantenimientos
                            </h3>
                            <Button
                                icon="pi pi-times"
                                className="p-button-text p-button-rounded"
                                onClick={cerrarTablaConsultaEntradas}
                                style={{ color: '#6b7280' }}
                            />
                        </div>

                        <div style={{ marginBottom: '16px' }}>
                            <div style={{ position: 'relative' }}>
                                <i className="pi pi-search" style={{
                                    position: 'absolute',
                                    left: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    color: '#9ca3af',
                                    fontSize: '0.9rem'
                                }}></i>
                                <InputText
                                    style={{
                                        width: '100%',
                                        height: '36px',
                                        paddingLeft: '35px',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '6px',
                                        fontSize: '0.9rem'
                                    }}
                                    placeholder="Buscar por folio u observaciones..."
                                    value={searchTermSalida}
                                    onChange={(e) => setSearchTermSalida(e.target.value)}
                                />
                            </div>
                        </div>

                        <div style={{ 
                            marginBottom: '12px', 
                            fontSize: '0.85em', 
                            color: '#6b7280',
                            padding: '6px 10px',
                            backgroundColor: '#f9fafb',
                            borderRadius: '4px',
                            border: '1px solid #e5e7eb'
                        }}>
                            📊 Mostrando <strong>{filteredSalidas.length}</strong> de <strong>{salidasConsulta.length}</strong> mantenimientos
                        </div>

                        {/* Tabla con DataTable de PrimeReact */}
                        <div style={{ flex: 1, overflow: 'hidden' }}>
                            <DataTable 
                                value={filteredSalidas}
                                scrollable 
                                scrollHeight="flex"
                                emptyMessage="📭 No hay registros"
                                size="small"
                                stripedRows
                                rowHover
                                onRowClick={(e) => handleSeleccionarSalida(e.data as MantenimientoType)}                                style={{ 
                                    fontSize: '0.85rem',
                                    cursor: 'pointer'
                                }}
                                rowClassName={() => 'cursor-pointer'}
                            >
                                <Column 
                                    field="folio" 
                                    header="📄 Folio" 
                                    style={{ 
                                        width: '100px',
                                        padding: '6px 8px',
                                        fontSize: '0.85rem',
                                        textAlign: 'center'
                                    }}
                                    headerStyle={{ 
                                        padding: '8px',
                                        fontSize: '0.9rem',
                                        fontWeight: '600'
                                    }}
                                />
                                <Column 
                                    field="fecha" 
                                    header="📅 Fecha" 
                                    style={{ 
                                        width: '120px',
                                        padding: '6px 8px',
                                        fontSize: '0.85rem',
                                        textAlign: 'center'
                                    }}
                                    headerStyle={{ 
                                        padding: '8px',
                                        fontSize: '0.9rem',
                                        fontWeight: '600'
                                    }}
                                    body={(rowData) => {
                                        const fecha = new Date(rowData.fecha);
                                        return fecha.toLocaleDateString('es-ES');
                                    }}
                                />
                                <Column 
                                    field="cve_producto" 
                                    header="🔑 Producto" 
                                    style={{ 
                                        width: '140px',
                                        padding: '6px 8px',
                                        fontSize: '0.85rem'
                                    }}
                                    headerStyle={{ 
                                        padding: '8px',
                                        fontSize: '0.9rem',
                                        fontWeight: '600'
                                    }}
                                />
                                <Column 
                                    field="observaciones" 
                                    header="📝 Observaciones" 
                                    style={{ 
                                        minWidth: '200px',
                                        padding: '6px 8px',
                                        fontSize: '0.85rem'
                                    }}
                                    headerStyle={{ 
                                        padding: '8px',
                                        fontSize: '0.9rem',
                                        fontWeight: '600'
                                    }}
                                />
                            </DataTable>
                        </div>
                    </div>
                </div>
            )}

            <div className="content-wrapper" style={{
                backgroundImage: 'url(/dist/img/FondoLogin.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundAttachment: 'fixed',
                minHeight: '100vh',
                position: 'relative',
                padding: '20px'
            }}>
                
                {/* Header principal mejorado */}
                <div style={{
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    borderRadius: '16px',
                    padding: '24px',
                    marginBottom: '20px',
                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                    border: '1px solid rgba(255, 255, 255, 0.2)'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                        <h1 style={{ 
                            margin: 0, 
                            color: '#1f2937', 
                            fontSize: '2rem', 
                            fontWeight: '700',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px'
                        }}>
                            🔧 Mantenimiento
                        </h1>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '8px 16px',
                            backgroundColor: modeInfo.color,
                            color: 'white',
                            borderRadius: '20px',
                            fontSize: '0.85rem',
                            fontWeight: '600'
                        }}>
                            <i className={`pi ${modeInfo.icon}`}></i>
                            {modeInfo.text}
                        </div>
                    </div>
                    <div style={{ height: '2px', background: 'linear-gradient(90deg, #3b82f6, #10b981)', borderRadius: '1px' }}></div>
                </div>

                {/* Botones de acción reorganizados */}
                <div style={{
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    borderRadius: '12px',
                    padding: '20px',
                    marginBottom: '20px',
                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                    border: '1px solid rgba(255, 255, 255, 0.2)'
                }}>
                    <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
                        {mode === 'view' ? (
                            <>
                                <Button
                                    icon="pi pi-search"
                                    label="Consultar Mantenimientos"
                                    className="p-button-info p-button-raised"
                                    onClick={handleBuscarSalida}
                                    style={{ 
                                        height: '44px',
                                        fontSize: '0.95rem',
                                        fontWeight: '600',
                                        borderRadius: '8px',
                                        minWidth: '180px'
                                    }}
                                />
                                <Button
                                    icon="pi pi-plus"
                                    label="Nuevo Mantenimiento"
                                    className="p-button-success p-button-raised"
                                    onClick={handleNuevo}
                                    style={{ 
                                        height: '44px',
                                        fontSize: '0.95rem',
                                        fontWeight: '600',
                                        borderRadius: '8px',
                                        minWidth: '160px'
                                    }}
                                />
                                <Button
                                    icon="pi pi-pencil"
                                    label="Editar"
                                    className="p-button-warning p-button-raised"
                                    onClick={handleEditar}
                                    disabled={!folio}
                                    style={{ 
                                        height: '44px',
                                        fontSize: '0.95rem',
                                        fontWeight: '600',
                                        borderRadius: '8px',
                                        minWidth: '120px',
                                        opacity: !folio ? 0.5 : 1
                                    }}
                                />
                                <Button
                                    icon="pi pi-trash"
                                    label="Eliminar"
                                    className="p-button-danger p-button-raised"
                                    onClick={handleEliminar}
                                    disabled={!folio}
                                    style={{ 
                                        height: '44px',
                                        fontSize: '0.95rem',
                                        fontWeight: '600',
                                        borderRadius: '8px',
                                        minWidth: '120px',
                                        opacity: !folio ? 0.5 : 1
                                    }}
                                />
                            </>
                        ) : (
                            <>
                                <Button
                                    icon="pi pi-save"
                                    label="Guardar"
                                    className="p-button-success p-button-raised"
                                    onClick={handleGuardar}
                                    style={{ 
                                        height: '44px',
                                        fontSize: '0.95rem',
                                        fontWeight: '600',
                                        borderRadius: '8px',
                                        minWidth: '120px'
                                    }}
                                />
                                <Button
                                    icon="pi pi-times"
                                    label="Cancelar"
                                    className="p-button-secondary p-button-raised"
                                    onClick={handleCancelar}
                                    style={{ 
                                        height: '44px',
                                        fontSize: '0.95rem',
                                        fontWeight: '600',
                                        borderRadius: '8px',
                                        minWidth: '120px'
                                    }}
                                />
                            </>
                        )}
                    </div>
                </div>

                {/* Formulario principal */}
                <div style={{
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    borderRadius: '12px',
                    padding: '24px',
                    marginBottom: '20px',
                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                    border: '1px solid rgba(255, 255, 255, 0.2)'
                }}>
                    <h3 style={{ 
                        margin: '0 0 20px 0', 
                        color: '#374151', 
                        fontSize: '1.3rem', 
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        📋 Información General
                    </h3>

                    <form onSubmit={(e) => e.preventDefault()} autoComplete="on">
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '20px' }}>
                            <div>
                                <label style={{ 
                                    display: 'block', 
                                    fontSize: '0.95rem', 
                                    fontWeight: '600',
                                    marginBottom: '8px',
                                    color: '#374151'
                                }}>
                                    📄 Folio <span style={{ color: '#ef4444' }}>*</span>
                                </label>
                                <InputText 
                                    value={folio} 
                                    disabled 
                                    style={{
                                        width: '100%',
                                        height: '40px',
                                        fontSize: '0.95rem',
                                        padding: '0 12px',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '8px',
                                        backgroundColor: '#f9fafb'
                                    }}
                                />
                            </div>
                            <div>
                                <label style={{ 
                                    display: 'block', 
                                    fontSize: '0.95rem', 
                                    fontWeight: '600',
                                    marginBottom: '8px',
                                    color: '#374151'
                                }}>
                                    📅 Fecha <span style={{ color: '#ef4444' }}>*</span>
                                </label>
                                <InputText 
                                    type="date" 
                                    value={fecha}
                                    onChange={(e) => setFecha(e.target.value)}
                                    disabled={isFechaDisabled}
                                    style={{
                                        width: '100%',
                                        height: '40px',
                                        fontSize: '0.95rem',
                                        padding: '0 12px',
                                        border: `2px solid ${isFechaDisabled ? '#e5e7eb' : '#3b82f6'}`,
                                        borderRadius: '8px',
                                        backgroundColor: isFechaDisabled ? '#f9fafb' : '#ffffff'
                                    }}
                                />
                            </div>
                            <div>
                                <label style={{ 
                                    display: 'block', 
                                    fontSize: '0.95rem', 
                                    fontWeight: '600',
                                    marginBottom: '8px',
                                    color: '#374151'
                                }}>
                                    👤 Usuario Capturó <span style={{ color: '#ef4444' }}>*</span>
                                </label>
                                {loading ? (
                                    <div style={{ padding: '10px', color: '#6b7280' }}>🔄 Cargando...</div>
                                ) : (
                                    <Dropdown 
                                        value={idUsuarioCapturo} 
                                        options={usuarios}
                                        optionLabel="nombre" 
                                        optionValue="id"
                                        disabled
                                        style={{
                                            width: '100%',
                                            height: '40px'
                                        }}
                                    />
                                )}
                            </div>
                            <div>
                                <label style={{ 
                                    display: 'block', 
                                    fontSize: '0.95rem', 
                                    fontWeight: '600',
                                    marginBottom: '8px',
                                    color: '#374151'
                                }}>
                                    🔧 Técnico <span style={{ color: '#ef4444' }}>*</span>
                                </label>
                                {loading ? (
                                    <div style={{ padding: '10px', color: '#6b7280' }}>🔄 Cargando técnicos...</div>
                                ) : (
                                    <Dropdown 
                                        value={idTecnico} 
                                        options={usuarios}
                                        optionLabel="nombre" 
                                        optionValue="id"
                                        onChange={(e) => setIdTecnico(e.value)}
                                        disabled={mode === 'view'}
                                        placeholder="Seleccione un técnico"
                                        style={{
                                            width: '100%',
                                            height: '40px'
                                        }}
                                    />
                                )}
                            </div>
                        </div>

                        {/* Producto a dar mantenimiento */}
                        <div style={{ marginBottom: '20px' }}>
                            <h4 style={{ 
                                margin: '0 0 16px 0', 
                                color: '#374151', 
                                fontSize: '1.1rem', 
                                fontWeight: '600',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}>
                                🎯 Producto a Dar Mantenimiento
                            </h4>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '20px' }}>
                                <div>
                                    <label style={{ 
                                        display: 'block', 
                                        fontSize: '0.95rem', 
                                        fontWeight: '600',
                                        marginBottom: '8px',
                                        color: '#374151'
                                    }}>
                                        🔑 Clave <span style={{ color: '#ef4444' }}>*</span>
                                    </label>
                                    <div style={{ display: 'flex', gap: '8px' }}>
                                        <InputText 
                                            value={cveProductoMantenimiento} 
                                            disabled 
                                            style={{
                                                flex: 1,
                                                height: '40px',
                                                fontSize: '0.95rem',
                                                padding: '0 12px',
                                                border: '2px solid #e5e7eb',
                                                borderRadius: '8px',
                                                backgroundColor: '#f9fafb'
                                            }}
                                        />
                                        <Button 
                                            icon="pi pi-search" 
                                            onClick={() => abrirBuscadorProductos('principal')} 
                                            disabled={mode === 'view'}
                                            style={{
                                                height: '40px',
                                                width: '40px',
                                                borderRadius: '8px'
                                            }}
                                            tooltip="Buscar producto"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label style={{ 
                                        display: 'block', 
                                        fontSize: '0.95rem', 
                                        fontWeight: '600',
                                        marginBottom: '8px',
                                        color: '#374151'
                                    }}>
                                        📝 Descripción
                                    </label>
                                    <InputText 
                                        value={descripcionProductoPrincipal} 
                                        disabled 
                                        style={{
                                            width: '100%',
                                            height: '40px',
                                            fontSize: '0.95rem',
                                            padding: '0 12px',
                                            border: '2px solid #e5e7eb',
                                            borderRadius: '8px',
                                            backgroundColor: '#f9fafb'
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Observaciones */}
                        <div style={{ marginBottom: '20px' }}>
                            <label style={{ 
                                display: 'block', 
                                fontSize: '0.95rem', 
                                fontWeight: '600',
                                marginBottom: '8px',
                                color: '#374151'
                            }}>
                                💬 Observaciones Generales
                            </label>
                            <InputTextarea 
                                value={observaciones} 
                                onChange={(e) => setObservaciones(e.target.value)}
                                rows={3} 
                                disabled={mode === 'view'}
                                placeholder="Ingrese observaciones generales del mantenimiento..."
                                style={{
                                    width: '100%',
                                    fontSize: '0.95rem',
                                    padding: '12px',
                                    border: `2px solid ${mode === 'view' ? '#e5e7eb' : '#3b82f6'}`,
                                    borderRadius: '8px',
                                    backgroundColor: mode === 'view' ? '#f9fafb' : '#ffffff',
                                    resize: 'vertical'
                                }}
                            />
                        </div>
                    </form>
                </div>

                {/* Sección de acciones rápidas */}
                <div style={{
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    borderRadius: '12px',
                    padding: '20px',
                    marginBottom: '20px',
                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                    border: '1px solid rgba(255, 255, 255, 0.2)'
                }}>
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'space-between',
                        marginBottom: '12px'
                    }}>
                        <h4 style={{ 
                            margin: 0, 
                            color: '#374151', 
                            fontSize: '1.1rem', 
                            fontWeight: '600',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            ⚡ Acciones Rápidas
                        </h4>
                        <Button 
                            label="Limpieza/Mantenimiento" 
                            icon="pi pi-cog"
                            className="p-button-info p-button-raised"
                            onClick={agregarLimpiezaMantenimiento}
                            disabled={mode === 'view'}
                            tooltip="Agregar servicio genérico de limpieza y mantenimiento"
                            tooltipOptions={{ position: 'top' }}
                            style={{
                                backgroundColor: '#17a2b8',
                                borderColor: '#17a2b8',
                                fontWeight: '600',
                                height: '40px',
                                borderRadius: '8px'
                            }}
                        />
                    </div>
                    <div style={{ 
                        padding: '12px 16px',
                        backgroundColor: '#f0f9ff',
                        borderRadius: '8px',
                        border: '1px solid #bae6fd',
                        fontSize: '0.9rem',
                        color: '#0c4a6e',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <i className="pi pi-info-circle" style={{ color: '#0284c7' }}></i>
                        <span>
                            Use este botón para agregar rápidamente un servicio de limpieza/mantenimiento general que no afecta el inventario.
                        </span>
                    </div>
                </div>

                {/* Detalles del mantenimiento */}
                <div style={{
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    borderRadius: '12px',
                    padding: '24px',
                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                    border: '1px solid rgba(255, 255, 255, 0.2)'
                }}>
                    <h3 style={{ 
                        margin: '0 0 20px 0', 
                        color: '#374151', 
                        fontSize: '1.3rem', 
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        🔧 Detalles del Mantenimiento
                        <Badge value={products.length} severity="info" style={{ marginLeft: '8px' }} />
                    </h3>

                    {/* Formulario de productos */}
                    <div style={{ 
                        display: 'grid', 
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
                        gap: '16px', 
                        marginBottom: '20px',
                        padding: '20px',
                        backgroundColor: '#f8fafc',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb'
                    }}>
                        <div>
                            <label style={{ 
                                display: 'block', 
                                fontSize: '0.9rem', 
                                fontWeight: '600',
                                marginBottom: '6px',
                                color: '#374151'
                            }}>
                                🔑 Producto <span style={{ color: '#ef4444' }}>*</span>
                            </label>
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <InputText 
                                    value={nombreProducto} 
                                    disabled 
                                    placeholder="Seleccione un producto"
                                    style={{
                                        flex: 1,
                                        height: '36px',
                                        fontSize: '0.9rem',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '6px',
                                        backgroundColor: '#f9fafb'
                                    }}
                                />
                                <Button 
                                    icon="pi pi-search" 
                                    onClick={() => abrirBuscadorProductos('detalle')} 
                                    disabled={mode === 'view'}
                                    size="small"
                                    style={{ height: '36px', borderRadius: '6px' }}
                                    tooltip="Buscar producto"
                                />
                            </div>
                        </div>
                        <div>
                            <label style={{ 
                                display: 'block', 
                                fontSize: '0.9rem', 
                                fontWeight: '600',
                                marginBottom: '6px',
                                color: '#374151'
                            }}>
                                📝 Descripción <span style={{ color: '#ef4444' }}>*</span>
                            </label>
                            <InputText 
                                value={DescripcionProducto} 
                                disabled 
                                style={{
                                    width: '100%',
                                    height: '36px',
                                    fontSize: '0.9rem',
                                    border: '2px solid #e5e7eb',
                                    borderRadius: '6px',
                                    backgroundColor: '#f9fafb'
                                }}
                            />
                        </div>
                        <div>
                            <label style={{ 
                                display: 'block', 
                                fontSize: '0.9rem', 
                                fontWeight: '600',
                                marginBottom: '6px',
                                color: '#374151'
                            }}>
                                🔢 Cantidad <span style={{ color: '#ef4444' }}>*</span>
                            </label>
                            <InputText 
                                type="number" 
                                min="1" 
                                value={cantidadProducto}
                                onChange={(e) => setCantidadProducto(e.target.value)}
                                disabled={mode === 'view'}
                                placeholder="1"
                                style={{
                                    width: '100%',
                                    height: '36px',
                                    fontSize: '0.9rem',
                                    border: `2px solid ${mode === 'view' ? '#e5e7eb' : '#3b82f6'}`,
                                    borderRadius: '6px',
                                    backgroundColor: mode === 'view' ? '#f9fafb' : '#ffffff'
                                }}
                            />
                        </div>
                        <div>
                            <label style={{ 
                                display: 'block', 
                                fontSize: '0.9rem', 
                                fontWeight: '600',
                                marginBottom: '6px',
                                color: '#374151'
                            }}>
                                💬 Observación
                            </label>
                            <InputText 
                                value={observacionProducto}
                                onChange={(e) => setObservacionProducto(e.target.value)}
                                disabled={mode === 'view'}
                                placeholder="Observaciones del producto..."
                                style={{
                                    width: '100%',
                                    height: '36px',
                                    fontSize: '0.9rem',
                                    border: `2px solid ${mode === 'view' ? '#e5e7eb' : '#3b82f6'}`,
                                    borderRadius: '6px',
                                    backgroundColor: mode === 'view' ? '#f9fafb' : '#ffffff'
                                }}
                            />
                        </div>
                    </div>

                    {/* Botones de producto */}
                    <div style={{ display: 'flex', gap: '8px', marginBottom: '20px', justifyContent: 'center' }}>
                        {editar ? (
                            <Button 
                                label="Actualizar" 
                                icon="pi pi-check"
                                onClick={updateProduct}
                                disabled={mode === 'view'}
                                size="small"
                                severity="warning"
                                style={{ 
                                    height: '36px',
                                    borderRadius: '6px',
                                    fontWeight: '600'
                                }}
                            />
                        ) : (
                            <Button 
                                label="Agregar" 
                                icon="pi pi-plus"
                                onClick={addProduct}
                                disabled={mode === 'view'}
                                size="small"
                                severity="success"
                                style={{ 
                                    height: '36px',
                                    borderRadius: '6px',
                                    fontWeight: '600'
                                }}
                            />
                        )}
                        <Button 
                            label="Limpiar" 
                            icon="pi pi-times"
                            onClick={clearProductFields}
                            disabled={mode === 'view'}
                            size="small"
                            severity="secondary"
                            outlined
                            style={{ 
                                height: '36px',
                                borderRadius: '6px'
                            }}
                        />
                    </div>

                   <ResponsiveMaintenanceTable
                        products={products}
                        appState={{ mode }}
                        onEditProduct={selectProductForEdit}
                        onDeleteProduct={deleteProduct}
                    />
                </div>
            </div>
        </>
    );
};

export default Mantenimiento;